import { inject, Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, catchError, of, switchMap, filter, withLatestFrom, Observable, throwError } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState } from "../root";
import { selectUser } from "../user/user.selectors";
import { IUser, ToastType } from "../../models";
import { ReportService } from "../../services/report/report.service";
import { ReportActions } from "./report.actions";
import { ColourMode, StylingService } from "../../services/styling/styling.service";
import { ToastService } from "../../services/toast/toast.service";
import { IReport } from "../../models/report.model";


@Injectable()
export class ReportEffects {
    private actions$ = inject(Actions);
    private store$ = inject(Store<AppState>);
    private toastService = inject(ToastService);
    private reportService: ReportService = inject(ReportService);
    private stylingService = inject(StylingService);

    loadReportList$ = createEffect(() => this.actions$.pipe(
        ofType(ReportActions.loadReportList),
        withLatestFrom(this.store$.select(selectUser)),
        filter((user) => !!user),
        switchMap(([action, user]) => {
            if (user === null) {
                return of()
            }
            let currentUser = user as IUser
            return this.reportService.getReportsByOrgID(currentUser.organisation_id)
        }),
        map((response) => {
            let responseStatus: string = response['status'] || 'error'
            if (responseStatus.toLowerCase() !== 'success') {
                const message = response['message']
                this.toastService.showToast("Failed to retrieve report list", ToastType.ERROR)
                return ReportActions.loadReportListFailure(message)
            }

            let reportsOrig = [...response['reports']]
            var _reports: IReport[] = []

            reportsOrig.forEach(report => {
                var _rep = { ...report } as IReport
                // _rep.arguments = [..._rep.arguments]
                // var _arg = []

                // if (typeof _rep.arguments == 'string') {
                //     _arg = JSON.parse(_rep.arguments)
                // } else {
                //     _arg = _rep.arguments
                // }

                // _arg.forEach((arg, index) => {
                //     if (typeof arg == 'string') {
                //         _rep.arguments[index] = JSON.parse(arg)
                //     } else {
                //         _rep.arguments[index] = arg
                //     }
                // })

                _reports.push(_rep)
            });
            return ReportActions.loadReportListSuccess({reports: _reports})

        }),
        catchError((error) => {
            this.toastService.showToast("Failed to retrieve report list", ToastType.ERROR)
            return of(ReportActions.loadReportListFailure(error))
        })
    ));

    fetchReportURL$ = createEffect(() => this.actions$.pipe(
      ofType(ReportActions.getReportURL),
      withLatestFrom(this.stylingService.colourMode$),
      switchMap(([action, colourMode]) => {
        return this.reportService.getDashboardURL(
          action.dashboardID,
          colourMode === ColourMode.DARK
        ).pipe(
          map(response => {
            return ReportActions.getReportURLSuccess({ url: response.url });
          }),
          catchError(error => {
            this.toastService.showToast("Failed to load Report!", ToastType.ERROR)
            return of(ReportActions.getReportURLFailure({ error }));
          })
        );
      })
    )
    );
}
